import { apiFetch } from '$lib/api/helpers';
import type { SceneLoadRequest, SceneLoadResponse } from '$lib/types/scene_load';

const PATH = '/scene_loads/';

export async function fetchSceneLoads() {
	return apiFetch<Array<SceneLoadResponse>>(PATH);
}

export async function fetchSceneLoadById(id: number) {
	return apiFetch<SceneLoadResponse>(`${PATH}${id}/`);
}

export async function createSceneLoad(sceneLoadRequest: SceneLoadRequest) {
	return apiFetch<SceneLoadResponse>(PATH, {
		method: 'POST',
		body: JSON.stringify(sceneLoadRequest)
	});
}

export async function createSceneLoads(sceneLoadRequests: Array<SceneLoadRequest>) {
	const responses: Array<SceneLoadResponse> = [];
	for (const sceneLoadRequest of sceneLoadRequests) {
		responses.push(await createSceneLoad(sceneLoadRequest));
	}
	return responses;
}

export async function updateSceneLoad(id: number, sceneLoadRequest: Partial<SceneLoadRequest>) {
	return apiFetch<SceneLoadResponse>(`${PATH}${id}/`, {
		method: 'PATCH',
		body: JSON.stringify(sceneLoadRequest)
	});
}

export async function deleteSceneLoad(id: number) {
	return apiFetch<void>(`${PATH}${id}/`, { method: 'DELETE' });
}
